import { createContext } from 'react';

const ReporteCuponesContext = createContext();

export default ReporteCuponesContext;
